        <div class="col bg-white" style="height: 100%;">
            <div>
                <div class="row actionsrequired mx-0">
                    <div class="col-9">
                        <span>{{lang?.Welcome}}&nbsp;</span>
                        <span>{{customerName | titlecase}}</span>
                    </div>
                    <div class="col-2 dropdown d-none d-md-block">
                                            </div>
                </div>
                <div>
                    <label id="label"><b>{{lang?.Last_Login}}&nbsp;</b></label>
                </div>
                <div>
                    <span id="label">{{loginTime | customDate : 'MMM-DD-YYYY h:mm a'}}</span>
                </div>
                            </div>
        </div>
        
        